import React from "react";
import DataGrid from "../../../../../dataGrid";
import GridConfig from "./gridConfig";
import { withStyles } from "@material-ui/core";
import styles from "../../../styles";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import StatusBar from "../../../../../dataGrid/StatusBar";
import { isEqual } from "lodash/lang";
import TerminalOnboardGridHeader from "./gridHeader";

class OnboardTerminalGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.gridApi = null;
    this.state = {
      selectedTerminals: [],
      isOnboardTerminalSelectOnGrid: false,
      quickFilterText: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.selectedTerminals, this.state.selectedTerminals)) {
      this.updateSelection();
    }
  }

  updateSelection = () => {
    if (this.gridApi) {
      this.gridApi.forEachNode((node) => {
        if (
          this.props.selectedTerminalIds.length > 0 &&
          this.props.selectedTerminalIds.includes(node.data.terminalId)
        ) {
          this.gridApi.ensureIndexVisible(node.rowIndex);
          node.setSelected(true, false, true);
        } else {
          node.setSelected(false, false, true);
        }
      });
      this.gridApi.dispatchEvent({
        type: "selectionChanged",
        api: this.gridApi,
      });
    }
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  constructStatusBar = () => {
    const totalOnboardTerminal = this.props.data.length;
    const statusBarData = [
      {
        label: totalOnboardTerminal + " Terminals",
        filterCondition: "",
      },
    ];
    return statusBarData;
  };

  onCellFocused = (params) => {
    if (this.props.isTerminalFormOpen) {
      if (!params.event.ctrlKey || this.state.selectedTerminals) {
        this.setState({
          isOnboardTerminalSelectOnGrid: true,
        });
      }
    }
  };
  onSelectionChanged = () => {
    if (this.props.terminalSelectedOnGrid && this.gridApi) {
      const selectedTerminals = this.gridApi
        .getSelectedRows()
        .map((anchor) => anchor);
      this.props.terminalSelectedOnGrid(selectedTerminals);
      this.setState({ selectedTerminals: selectedTerminals });
    }
  };
  
  updateQuickFilterText = (value) => {
    this.setState({
      quickFilterText: value,
    });
  };

  render() {
    const { config } = this.gridConfig;
    const {
      classes,
      error,
      data,
      onBoardTerminalFormOpen,
      isTerminalFormOpen,
    } = this.props;
    const { selectedTerminals } = this.state;
    return (
      <div className={classes.anchorSubModulePart}>
        <div className={classes.anchorPointModuleContainer}>
          <TerminalOnboardGridHeader
            gridApi={this.gridApi}
            selectedTerminals={selectedTerminals}
            isTerminalFormOpen={isTerminalFormOpen}
            onBoardTerminalFormOpen={onBoardTerminalFormOpen}
            updateQuickFilterText={this.updateQuickFilterText}
          />
          <div className={`${classes.dataGrid} ${classes.anchorPointContent}`}>
            <DataGrid
              defaultColDef={config.defaultColDef}
              columnDefs={config.columns}
              config={config}
              enableFilter={config.enableFilter}
              enableSorting={config.enableSorting}
              rowSelection={config.rowSelection}
              rowDeselection={config.rowDeselection}
              rowData={data}
              onGridReady={this.onGridReady}
              onSelectionChanged={this.onSelectionChanged}
              onRowDataChanged={this.updateSelection}
              suppressRowClickSelection={isTerminalFormOpen}
              onCellMouseDown={this.onCellFocused}
              quickFilterText={this.state.quickFilterText}
              panelLabel={(filteredData) => (
                <StatusBar
                  data={this.constructStatusBar(filteredData)}
                  filterGridData={this.updateGridData}
                />
              )}
              showErrorMessage={error}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default compose(withStyles(styles), withSnackbar)(OnboardTerminalGrid);
